
export default {
  name: 'ModalTerms'
}
